import { Dialog } from '@base-ui/react/dialog'
export const SteppedFormHandle = Dialog.createHandle()
